module.exports = __webpack_public_path__ + "static/img/34-2.53d5ea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/34-2.jpg
// module id = Ftpz
// module chunks = 0